import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";

const STAGES = ["Reading your question…", "Checking the chart context…", "Writing a clear answer…", "Almost there — longer answers take a few more seconds…"];

// Visible progress for AI answers (replies arrive in one piece, so we show live progress instead of a silent "…").
export const ThinkingState = ({ who = "Craft Coach", testid = "ai-thinking" }) => {
  const [secs, setSecs] = useState(0);
  useEffect(() => { const t = setInterval(() => setSecs((s) => s + 1), 1000); return () => clearInterval(t); }, []);
  const stage = STAGES[Math.min(STAGES.length - 1, Math.floor(secs / 4))];
  return (
    <div className="flex items-center gap-2 text-sm text-tc-sub" data-testid={testid} aria-live="polite">
      <Loader2 className="w-4 h-4 animate-spin text-tc-coach shrink-0" />
      <span>{who} is thinking · {stage}</span>
      <span className="font-mono text-[11px] text-tc-muted">{secs}s</span>
    </div>
  );
};

export default ThinkingState;
